/*
 * @Author: your name
 * @Date: 2020-12-25 16:13:07
 * @LastEditTime: 2020-12-25 17:18:37
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/store/modules/login.js
 */
/*
 * @Descripttion: 登录
 * @FilePath: /mall-wap-vue/src/store/modules/login.js
 * @Author: 张兴业
 * @Date: 2020-09-24 15:09:40
 * @LastEditors: 张兴业
 * @LastEditTime: 2020-12-25 11:02:45
 */
import {
  accountLogin,
  sendSms,
  phoneLogin,
  wechatLogin,
  phoneBinding,
  checkVerifyCode,
  getGuestToken
} from "@/api/login";
import { setToken } from "@/utils/authority";

const state = {
  token: {}
};

const mutations = {
  SET_LOGIN(state, data) {
    state.token = data.access_token;
  }
};

const actions = {
  // 手机号密码登录
  async accountLogin({ commit }, { params }) {
    const response = await accountLogin(params);
    if (response.code === 1) {
      commit("SET_LOGIN", response.data);
      setToken(response.data);
      return Promise.resolve();
    } else return Promise.reject(response);
  },
  // 发送验证码
  async sendSms({ commit }, { params }) {
    const response = await sendSms(params);
    // console.log(response, "验证码");
    if (response.code === 1) {
      commit("", response.data);
      return Promise.resolve();
    } else return Promise.reject(response);
  },
  // 手机号验证码登录
  async phoneLogin({ commit }, { params }) {
    const response = await phoneLogin(params);
    // console.log(response, "手机号登录");
    if (response.code === 1) {
      commit("", response.data);
      setToken(response.data);
      return Promise.resolve();
    } else return Promise.reject(response);
  },
  // 微信登录
  async wechatLogin({ commit }, { params }) {
    const response = await wechatLogin(params);
    // console.log(response, "微信登录");
    if (response.code === 1) {
      commit("", response.data);
      setToken(response.data);
      return Promise.resolve(response.data);
    } else if (response.code === 1000) {
      setToken(response.data);
      // 微信登录成功未绑定手机号跳转手机号页面
      window.location.href = `/binding`;
      localStorage.setItem("wap-mall-code", response.data.code);
    } else return Promise.reject(response);
  },
  // 微信登录后绑定手机号
  async phoneBinding({ commit }, { params }) {
    const response = await phoneBinding(params);
    if (response.code === 1) {
      commit("", response.data);
      setToken(response.data);
      return Promise.resolve(response.data);
    } else return Promise.reject(response);
  },
  // 校验验证码
  async checkVerifyCode({ commit }, { params }) {
    const response = await checkVerifyCode(params);
    if (response.code === 1) {
      commit("", response.data);
      return Promise.resolve();
    } else return Promise.reject();
  },
  // 获取游客token
  async getGuestToken({ commit }) {
    const response = await getGuestToken();
    if (response.code === 1) {
      commit("SET_LOGIN", response.data);
      setToken(response.data);
      return Promise.resolve(response.data);
    } else return Promise.reject(response);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
